import mixpanel from "mixpanel-browser"

// Initialize Mixpanel with ad-blocker bypass (no Django conflicts)
const initMixpanel = () => {
  // Only initialize on dashboard.plaex.net
  if (window.location.hostname !== "dashboard.plaex.net") {
    return
  }

  mixpanel.init("b45c71b0009ed69511845754c7ea7503", {
    debug: false, // Set to false in production
    track_pageview: true,
    persistence: "cookie",
    autocapture: true,
    record_sessions_percent: 5,

    // ✅ Use your domain as api_host (bypasses ad blockers)
    api_host: "https://dashboard.plaex.net",

    // Cookie settings for dashboard.plaex.net only
    cookie_domain: "dashboard.plaex.net",
    cross_subdomain_cookie: false,
    secure_cookie: true,
    cookie_name: "mp_dashboard_plaex",

    // ✅ Custom API routes that don't conflict with Django /api/*
    api_routes: {
      track: "/analytics/events", // Mixpanel tracking
      engage: "/analytics/users", // Mixpanel user profiles
      decide: "/analytics/config", // Mixpanel feature flags
    },

    loaded: (mixpanel) => {

      // Test tracking
      mixpanel.track("Dashboard Initialized", {
        timestamp: new Date().toISOString(),
        ad_blocker_bypass: true,
        domain: window.location.hostname,
        user_agent: navigator.userAgent,
        mixpanel_paths: ["/analytics/events", "/analytics/users", "/analytics/config"],
      })
    },
  })
}

// Utility functions for tracking
export const trackEvent = (eventName, properties = {}) => {
  if (window.location.hostname !== "dashboard.plaex.net") return

  const enhancedProperties = {
    ...properties,
    timestamp: new Date().toISOString(),
    page: window.location.pathname,
    domain: window.location.hostname,
    url: window.location.href,
  }

  mixpanel.track(eventName, enhancedProperties)
}

export const identifyUser = (userId, userProperties = {}) => {
  if (window.location.hostname !== "dashboard.plaex.net") return

  mixpanel.identify(userId)

  const enhancedProperties = {
    ...userProperties,
    $last_seen: new Date().toISOString(),
    platform: "dashboard",
    domain: "dashboard.plaex.net",
  }

  mixpanel.people.set(enhancedProperties)
}

export const trackPageView = (pageName, properties = {}) => {
  trackEvent("Page Viewed", {
    page_name: pageName,
    ...properties,
  })
}

// Waste management specific tracking (based on your Django models)
export const trackWasteEvent = (action, binRef, properties = {}) => {
  trackEvent(`Waste ${action}`, {
    bin_ref: binRef,
    waste_action: action.toLowerCase(),
    ...properties,
  })
}

export const trackBinEvent = (action, binRef, properties = {}) => {
  trackEvent(`Bin ${action}`, {
    bin_ref: binRef,
    bin_action: action.toLowerCase(),
    ...properties,
  })
}

// Login form specific tracking (for your Dutch form)
export const trackLoginFormEvent = (action, properties = {}) => {
  trackEvent(`Login Form ${action}`, {
    form_action: action.toLowerCase(),
    form_language: "dutch",
    form_type: "login",
    ...properties,
  })
}

export const trackLoginAttempt = (success, errorType = null) => {
  trackEvent("Login Attempt", {
    success,
    error_type: errorType,
    form_language: "dutch",
    login_method: "email_password",
  })
}

// Dashboard navigation tracking
export const trackDashboardNavigation = (section, properties = {}) => {
  trackEvent("Dashboard Navigation", {
    section: section,
    navigation_type: "menu_click",
    ...properties,
  })
}

// API interaction tracking (for your Django API calls)
export const trackAPICall = (endpoint, method, success, properties = {}) => {
  trackEvent("API Call", {
    endpoint: endpoint,
    method: method,
    success: success,
    api_type: "django",
    ...properties,
  })
}

export default initMixpanel